// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___-Y0r","top":"styles_top__bG4Dy","left":"styles_left__1rzRV","description":"styles_description__3LHg6"};